import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ProductM } from '../utils/models';
import { from, lastValueFrom, map, Observable } from 'rxjs';
import { CacheS } from './cache-s';

@Injectable({
  providedIn: 'root',
})
export class ProductS {
  http = inject(HttpClient);
  cache = inject(CacheS);
  url = `${environment.apiUrl}/Product`;

  add(model: FormData): Observable<ProductM> {
    return this.http.post<ProductM>(this.url, model);
  }

  search(params: any): Observable<ProductM[]> {
    return this.http.post<ProductM[]>(this.url + "/Search", params);
  }

  get(id: string): Observable<ProductM> {
    return this.http.get<ProductM>(`${this.url}/${id}`);
  }

  update(id: string, updateRequest: ProductM): Observable<ProductM> {
    return this.http.put<ProductM>(`${this.url}/${id}`, updateRequest);
  }

  delete(id: string): Observable<ProductM> {
    return this.http.delete<ProductM>(`${this.url}/${id}`);
  }

}
